// LT-311 — Senders sub-route. Thin wrapper around the shared
// EmailSendersTab component, owning a local toast state so the tab is
// self-contained at /settings/senders.
import React, { useEffect, useState } from 'react';
import EmailSendersTab from '../../components/EmailSendersTab';

type Toast = { type: 'success' | 'error'; message: string };

const SettingsSendersTab: React.FC = () => {
  const [toast, setToast] = useState<Toast | null>(null);

  useEffect(() => {
    if (toast?.type === 'success') {
      const t = setTimeout(() => setToast(null), 5000);
      return () => clearTimeout(t);
    }
  }, [toast]);

  return (
    <div className="space-y-3">
      {toast ? (
        <div
          role={toast.type === 'error' ? 'alert' : 'status'}
          className={`rounded-ds-lg px-3 py-2 text-sm border ${
            toast.type === 'success'
              ? 'bg-ok-tint border-ok-border text-ok-text'
              : 'bg-danger-tint border-danger-border text-danger-text'
          }`}
        >
          {toast.message}
        </div>
      ) : null}
      <EmailSendersTab setMessage={setToast} />
    </div>
  );
};

export default SettingsSendersTab;
